<div class="ticket-detail-container">
  
  <!-- PAGE HEADER -->
  <div class="page-header">
    <a  class="go-back-link" (click)="backToList()">
      <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
      Go Back
    </a>
    
    <div class="header-content">
    </div>
  </div>
  
  <!-- TICKET INFO SECTION -->
  <div *ngIf="ticket" class="ticket-info-section">
    <div class="ticket-id-row">
      <div class="ticket-id">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z" />
        </svg>
        Ticket ID: {{ ticket.id }}
      </div>
      <span class="status-badge" [ngClass]="ticket.ticket_status">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <circle cx="10" cy="10" r="4"/>
        </svg>
        {{ ticket.ticket_status | titlecase }}
      </span>
      
      <div class="ticket-actions">
        <button class="btn-ticket-action" (click)="refreshTicket()" title="Refresh">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
        </button>
        <button class="btn-ticket-action delete" (click)="deleteTicket()" title="Delete">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
        </button>
      </div>
    </div>
    <div class="ticket-subject">
      <strong>Subject:</strong> {{ ticket.subject }}
    </div>
    <div class="ticket-description">
      <strong>Description:</strong> {{ ticket.description }}
    </div>
  </div>
  
  <!-- MAIN CONTENT -->
  <div class="main-content">
    
    <!-- CHAT SECTION -->
    <div class="chat-section">
      <div class="chat-header">
        <div class="chat-title">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z" />
          </svg>
          Conversation
        </div>
      </div>
      
      <div class="chat-messages" #chatMessages>
        
        <!-- Message Loop -->
        <div *ngFor="let message of messages" 
             class="message" 
             [ngClass]="message.isUser ? 'user' : 'other'">
          <div class="message-header">
            <span class="message-author">{{ message.author }}</span>
            <span class="message-time">{{ message.timeAgo }}</span>
          </div>
          
          <div class="message-bubble" *ngIf="message.text">
            {{ message.text }}
          </div>
             <div *ngIf="message.chat_image" class="ImgUpload">
                        <a href="{{message.chat_image}}" target="_blank"
                      class="cursor-pointer">
                      <img style="    height: 100px;
    width: 100px;
    border-radius: 16px;" [src]="message.chat_image" />
                    </a>
                
              </div>
          <!-- Attachments -->
        
        </div>
        
      </div>
      
      <!-- MESSAGE INPUT -->
      <div class="message-input-section">
        
        <!-- Image/File Preview Section -->
        <div class="image-preview-section" [class.has-images]="selectedFilePreviews.length > 0">
          
          <ng-container *ngFor="let preview of selectedFilePreviews; let i = index">
            <!-- Image Preview -->
            <div class="image-preview-item" *ngIf="preview.isImage">
              <img [src]="preview.url" [alt]="preview.file.name">
              <button class="image-preview-remove" (click)="removeFile(i)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <!-- File Preview -->
            <div class="file-preview-item" *ngIf="!preview.isImage">
              <div class="file-preview-icon" style="height: 150px;width: 150px;">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>
              </div>
              <div class="file-preview-info" style="height: 150px;width: 150px;">
                <div class="file-preview-name">{{ preview.file.name }}</div>
                <div class="file-preview-size">{{ formatFileSize(preview.file.size) }}</div>
              </div>
              <button class="file-preview-remove" (click)="removeFile(i)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </ng-container>
          
        </div>
        
        <div *ngIf="showBtn"  class="message-input-container">
          <textarea 
            class="message-textarea" 
            placeholder="Write your message..." 
            [(ngModel)]="messageText"
            [maxlength]="maxChars"
            (input)="updateCharCount()">
          </textarea>
          <div class="char-count" [ngClass]="getCharCountClass()">{{ charCount }}/{{ maxChars }}</div>
        </div>
        
        <input type="file" 
               #fileInput
               class="file-input-hidden" 
               accept="image/*"
               multiple
               (change)="onFileSelect($event)">
        
        <div *ngIf="showBtn"  class="input-actions">
          <div class="input-actions-left">
            <button class="btn-attach" (click)="openFileSelector()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
              </svg>
              Attach Files
            </button>
          </div>
          
          <div class="input-actions-right">
            <div class="status-toggle">
              <button class="status-toggle-btn" 
                      [class.active]="currentStatus === 'open'"
                      (click)="toggleStatus('open')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <circle cx="10" cy="10" r="4"/>
                </svg>
                Open
              </button>
              <button class="status-toggle-btn" 
                      [class.active]="currentStatus === 'close'"
                      (click)="toggleStatus('close')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                </svg>
                Close
              </button>
            </div>
            <button class="btn-send" (click)="sendMessage()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
              </svg>
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- ATTACHMENTS SIDEBAR -->
    <div class="attachments-sidebar">
      <div class="sidebar-header">
        <div class="sidebar-title">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
          </svg>
          Uploaded Attachments
        </div>
      </div>
      
      <div class="attachments-list">
    
        <div class="attachment-item" *ngFor="let attachment of attachments">
         <div class="attachment-icon"
     [ngClass]="{'image': attachment.type.startsWith('image/')}">

  <!-- ✅ Show actual image if file is image -->
  <img *ngIf="attachment.type.startsWith('image/')"
       [src]="attachment.url"
       alt="Preview"
       style="width: 48px; height: 48px; object-fit: cover; border-radius: 6px;" />

  <!-- ✅ Show SVG icon if NOT image -->
  <svg *ngIf="!attachment.type.startsWith('image/')"
       xmlns="http://www.w3.org/2000/svg"
       fill="none"
       viewBox="0 0 24 24"
       stroke-width="2"
       stroke="currentColor">
    <path stroke-linecap="round"
          stroke-linejoin="round"
          d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
  </svg>

</div>

          <div class="attachment-info">
            <div class="attachment-name">{{ attachment.name }}</div>
            <!-- <div class="attachment-meta">{{ formatFileSize(attachment.size) }} • {{ attachment.type.split('/')[0] | titlecase }}</div> -->
          </div>
          <button class="attachment-download" (click)="downloadAttachment(attachment.url)" title="Download">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>
          </button>
        </div>
        
    
        <div class="empty-attachments" *ngIf="attachments.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
          </svg>
          <p>No attachments</p>
        </div>
        
      </div>
    </div>
    
  </div>
  
</div>
